/* eslint-disable */
import React, { useEffect } from 'react'

export default function RootLayout({ children }: { children: React.ReactNode }) {

  return (

      <html lang="en" className="min-h-screen">
        <body className="min-h-screen">
          <div className="h-full">
            <div className="bg-white p-4 shadow-md w-full md:max-w-[1024px] min-h-[640px] mx-auto notes-content h-full">
              {children}
            </div>
          </div>
        </body>
      </html>

  )
}
